var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconPlayForSubHeader(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.92286 22.1745C7.50956 22.4402 7.09345 22.4545 6.67451 22.2173C6.2556 21.9801 6.04614 21.6173 6.04614 21.1289V6.7416C6.04614 6.25318 6.2556 5.89036 6.67451 5.65316C7.09345 5.41596 7.50956 5.43022 7.92286 5.69594L19.2323 12.9111C19.6118 13.1553 19.8015 13.498 19.8015 13.9391C19.8015 14.3802 19.6118 14.7203 19.2323 14.9594L7.92286 22.1745Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPlayForSubHeader);
export default __webpack_public_path__ + "static/media/iconPlayForSubHeader.a7b919eb.svg";
export { ForwardRef as ReactComponent };